<template>
  <div>
    <van-popup
      v-model="show"
      round
      position="bottom"
      class="review-detail-popup"
    >
      <div class="flex-col flex-align-center flex-justify-center">
        <van-row
          class="review-detail-popup-item"
          type="flex"
          justify="center"
          @click="handleShare('0')"
        >
          <van-col>
            <img
              class="review-detail-popup-item-img-we"
              src="./img/weixin3.png"
            />
          </van-col>
          <van-col class="review-detail-popup-item-text">分享至微信</van-col>
        </van-row>
        <van-row
          class="review-detail-popup-item"
          type="flex"
          justify="center"
          @click="handleShare('1')"
        >
          <van-col>
            <img
              class="review-detail-popup-item-img-friend"
              src="./img/friend3.png"
            />
          </van-col>
          <van-col class="review-detail-popup-item-text">朋友圈</van-col>
        </van-row>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false
    }
  },
  methods: {
    handleShare(type) {
      this.$emit('handleShare', type)
    }
  }
}
</script>
<style scoped lang="less">
.review-detail-popup {
  // height: 119px;
  padding: 20px 0;
  text-align: center;
  font-size: 15px;
  color: #666;
  &-item {
    &:last-child {
      margin-top: 20px;
    }
  }
  &-item-text {
    margin-left: 9px;
  }
  &-item-img-we {
    width: 28px;
    height: 23px;
  }
  &-item-img-friend {
    width: 26px;
    height: 26px;
  }
}
</style>
